import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import Container from "@material-ui/core/Container";
import CssBaseline from "@material-ui/core/CssBaseline";
import Form from "react-validation/build/form";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Link from "@components/Link";
import { logoutUser } from "@js-shared/lib/actions/userActions";
import Alert from "@material-ui/lab/Alert";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Avatar from "@material-ui/core/Avatar";
import { makeStyles } from "@material-ui/core/styles";
import { Typography, CircularProgress } from "@material-ui/core";
import PublicPage from "@components/PublicPage";
import dynamic from "next/dynamic";
import useResetPassword from "@js-shared/lib/hooks/useResetPassword";

const Footer = dynamic(() => import("@components/Homepage/Footer"));

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    height: "93vh",
    marginTop: theme.spacing(2),
  },
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  circularProgress: {
    color: 'grey',
    height: 2
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
}));

function ResetPassword(props) {
  const classes = useStyles();
  let form = useRef(null);

  React.useEffect(() => {
    props.logoutUser()
  }, [])

  const {
    email,
    setEmail,
    successMessage,
    successful,
    error,
    errorMessage,
    loading,
    handleResetPassword,
  } = useResetPassword();

  return (
    <PublicPage>
      <Grid container component="main" className={classes.root}>
        <Container component="main" maxWidth="xs">
          <CssBaseline />
          <div className={classes.paper}>
            <Avatar className={classes.avatar}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              Reset Password
            </Typography>
            <Form
              className={classes.form}
              onSubmit={(e) => {
                e.preventDefault();
                form.validateAll();
                handleResetPassword();
              }}
              ref={(c) => {
                form = c;
              }}
              method="POST"
            >
              {!successful && (
                <>
                  <Grid
                    container
                    justify="center"
                    style={{
                      marginTop: "10px",
                      marginBottom: "10px",
                      textAlign: "center",
                    }}
                  >
                    <Grid item>
                      <Link
                        href="/login"
                        variant="body2"
                        style={{ color: "#969696" }}
                      >
                        We will send you an email with instructions for you to
                        set a new password
                      </Link>
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        type="text"
                        id="email"
                        label="Email"
                        name="email"
                        autoFocus
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </Grid>
                  </Grid>
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="primary"
                    className={classes.submit}
                    disabled={loading}
                    disableElevation
                    startIcon={
                      loading && (
                        <CircularProgress
                          color="disabled"
                          size={22}
                          // className={classes.circularProgress}
                        />
                      )
                    }
                  >
                    <span>Send Email</span>
                  </Button>
                  {/* {loading && <CircularProgress />} */}
                  {error && (
                    <Grid item xs={12}>
                      <Alert severity="error">{errorMessage}</Alert>
                    </Grid>
                  )}
                  <Grid
                    container
                    justify="center"
                    style={{ marginTop: "10px" }}
                  >
                    <Grid item>
                      <Link href="/login" variant="body2">
                        Back to Login
                      </Link>
                    </Grid>
                  </Grid>
                </>
              )}
            </Form>
            {successful && (
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Alert severity="success">{successMessage}</Alert>
                </Grid>
              </Grid>
            )}
          </div>
        </Container>
        {/* Homepage Footer Component */}
        <Footer />
      </Grid>
    </PublicPage>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    logoutUser: () => dispatch(logoutUser()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);
// export default ResetPassword;
